import React from 'react';
import { ScrollText } from '..';
import { Container, Title } from '../styled/styled';
import { AnimationSybTitle, AnimationSybTitle1 } from '../styled/animations';

import react from '../../image/about-icon/react.png';
import node from '../../image/about-icon/node.png';
import vue from '../../image/about-icon/vue.png';
import solidity from '../../image/about-icon/solidity.png';
import js from '../../image/about-icon/js.png';
import angular from '../../image/about-icon/angular.png';
import ellipse from '../../image/Ellipse.svg';

import styled from 'styled-components';

const mokImage = [
  {
    id: 1,
    image: react,
  },
  {
    id: 2,
    image: node,
  },
  {
    id: 3,
    image: vue,
  },
  {
    id: 4,
    image: solidity,
  },
  {
    id: 5,
    image: js,
  },
  {
    id: 6,
    image: angular,
  },
];

const AboutStyled = styled.div`
  margin-top: -80px;
  height: 100vh;
  display: flex;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    right: -50px;
    bottom: -200px;
    background: url(${ellipse}) no-repeat center;
    width: 565px;
    height: 100%;
  }
  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    line-height: 47px;
    text-align: justify;
    color: #000000;
  }

  @media (max-width: 1920px) {
    .content {
      margin-top: 10px;
    }
  }
  @media (max-width: 1500px) {
    &::after {
      bottom: -100px;
    }
  }
  @media (max-width: 1200px) {
    max-width: 100%;

    h2 {
      font-size: 24px;
      line-height: 37px;
    }
  }
  @media (max-width: 992px) {
    h2 {
      font-size: 18px;
      line-height: 27px;
    }
    &::after {
      display: none;
    }
  }
  @media (max-width: 440px) {
    h2 {
      font-size: 16px;
      line-height: 24px;
    }
  }
  @media (max-height: 660px) {
    h2 {
      font-size: 14px;
      line-height: 18px;
    }
    h1 {
      font-size: 20px;
    }
  }
  @media (max-height: 460px) {
    margin-top: -50px;
    h2 {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      text-align: justify;
    }
    h1 {
      font-size: 16px;
    }
  }
`;

const AboutContent = styled.div`
  margin-top: 20px;
`;

const AboutImage = styled.div`
  max-width: 1050px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  img {
    width: 70%;
    height: 100%;
  }
  @media (max-height: 460px) {
    img {
      width: 30%;
      height: 100%;
    }
  }
`;

const AbouteImageItem = styled.div`
  max-width: 33% !important;
  width: 100%;
`;

export const About = () => {
  return (
    <AboutStyled id="about">
      <Container>
        <AnimationSybTitle>
          <h2>
            Our team includes developers, a project manager, a designer and QA, the CTO of the
            company is a senior developer with 8 years of commercial experience in the IT field.
          </h2>
        </AnimationSybTitle>
        <AboutContent>
          <Title>WE USE SUCH TECHNOLOGIES</Title>
          <AboutImage>
            {mokImage.map((item) => (
              <AbouteImageItem key={item.id}>
                <img src={item.image} alt="" />
              </AbouteImageItem>
            ))}
          </AboutImage>
        </AboutContent>
        <AnimationSybTitle1>
          <h2>
            Writing smart contracts, connecting cryptocurrency payment options, referral programs,
            as well as the development of websites, web portals, mobile applications and many other
            areas are part of the scope of our work.
          </h2>
        </AnimationSybTitle1>
        <ScrollText>SCROLL DOWN TO WATCH OUR PORTFOLIO</ScrollText>
      </Container>
    </AboutStyled>
  );
};
